import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5a26e711"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "scaner-container"
};
const _hoisted_2 = {
  class: "cover"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "line"
}, null, -1));

const _hoisted_4 = {
  class: "tips"
};
const _hoisted_5 = {
  class: "photo-btn"
};
const _hoisted_6 = {
  class: "video-wrapper"
};
const _hoisted_7 = ["src"];
import { ref, onMounted, onBeforeUnmount } from 'vue';
import jsQR from 'jsqr';
import { Toast } from 'vant';
import 'vant/es/toast/style';
import { useI18n } from 'vue-i18n';
export default {
  __name: 'ScanQrcode',
  emits: ['hide', 'code'],

  setup(__props, {
    emit
  }) {
    const {
      t
    } = useI18n();
    let toastLoading = null;
    const video = ref();
    const canvasRef = ref();
    const qrcode = ref('');
    const imgSrc = ref('');
    const upImg = ref();
    const codePositionX = ref(null);
    const codePositionY = ref(null);
    let tickTimer = null;

    const tick = () => {
      if (video.value && video.value.readyState === video.value.HAVE_ENOUGH_DATA) {
        canvasRef.value.width = video.value.clientWidth;
        canvasRef.value.height = video.value.clientHeight;
        const canvas = canvasRef.value.getContext("2d");
        canvas.imageSmoothingEnabled = false;
        canvas.drawImage(video.value, 0, 0, video.value.clientWidth, video.value.clientHeight);
        const imageData = canvas.getImageData(0, 0, video.value.clientWidth, video.value.clientHeight);
        const code = jsQR(imageData.data, imageData.width, imageData.height, {
          inversionAttempts: "dontInvert"
        });

        if (code) {
          qrcode.value = code.data;
          codePositionX.value = code.location.topLeftCorner.x + (code.location.bottomRightCorner.x - code.location.topLeftCorner.x) / 2 - 25;
          codePositionY.value = code.location.topLeftCorner.y + (code.location.bottomRightCorner.y - code.location.topLeftCorner.y) / 2 - 25;
          video.value.pause();
          emit('code', code.data);
        }
      }

      tickTimer = setTimeout(tick, 250);
    };

    const afterRead = file => {
      toastLoading = Toast.loading({
        duration: 0,
        loadingType: 'spinner',
        forbidClick: false
      });
      video.value.pause();
      clearTimeout(tickTimer);
      imgSrc.value = file.content;
    };

    const imgLoad = () => {
      canvasRef.value.width = upImg.value.width;
      canvasRef.value.height = upImg.value.height;
      const canvas = canvasRef.value.getContext("2d");
      canvas.imageSmoothingEnabled = false;
      canvas.drawImage(upImg.value, 0, 0, upImg.value.width, upImg.value.height);
      const imageData = canvas.getImageData(0, 0, upImg.value.width, upImg.value.height);
      const code = jsQR(imageData.data, imageData.width, imageData.height);

      if (toastLoading) {
        toastLoading.clear();
      }

      if (code) {
        emit('code', code.data);
      } else {
        Toast({
          message: t('scanError'),
          position: 'bottom'
        });
        video.value.play();
        tickTimer = setTimeout(tick, 250);
      }
    };

    const init = () => {
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        const facingMode = {
          exact: 'environment'
        };

        const handleSuccess = stream => {
          if (video.value.srcObject !== undefined) {
            video.value.srcObject = stream;
          } else if (window.videoEl.mozSrcObject !== undefined) {
            video.value.mozSrcObject = stream;
          } else if (window.URL.createObjectURL) {
            video.value.src = window.URL.createObjectURL(stream);
          } else if (window.webkitURL) {
            video.value.src = window.webkitURL.createObjectURL(stream);
          } else {
            video.value.src = stream;
          }

          video.value.playsInline = true;
          video.value.play().then(() => {
            tick();
          }).catch(() => {
            Toast({
              message: t('scanInitErr'),
              position: 'bottom'
            });
          });
        };

        navigator.mediaDevices.getUserMedia({
          video: {
            facingMode,
            width: 1280,
            height: 720
          }
        }).then(handleSuccess).catch(() => {
          navigator.mediaDevices.getUserMedia({
            video: true
          }).then(handleSuccess).catch(() => {
            Toast({
              message: t('noCamera'),
              position: 'bottom'
            });
            emit('hide');
          });
        });
      }
    };

    onMounted(() => {
      init();
    });
    onBeforeUnmount(() => {
      clearTimeout(tickTimer);

      if (video.value && video.value.srcObject) {
        video.value.srcObject.getTracks().forEach(t => t.stop());
      }
    });
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");

      const _component_van_uploader = _resolveComponent("van-uploader");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "back",
        onClick: _cache[0] || (_cache[0] = $event => emit('hide'))
      }, [_createVNode(_component_van_icon, {
        name: "cross",
        size: "25px"
      })]), _createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_uploader, {
        "after-read": afterRead
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_van_icon, {
          name: "photo-o",
          size: "28",
          "max-count": 1
        })])]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("video", {
        class: "source",
        ref_key: "video",
        ref: video
      }, null, 512), qrcode.value !== '' ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "code-indicator",
        style: _normalizeStyle({
          top: codePositionY.value + 'px',
          left: codePositionX.value + '20px'
        })
      }, null, 4)) : _createCommentVNode("", true)]), _withDirectives(_createElementVNode("canvas", {
        class: "canvas-video",
        ref_key: "canvasRef",
        ref: canvasRef
      }, null, 512), [[_vShow, false]]), _withDirectives(_createElementVNode("img", {
        style: {
          "position": "absolute",
          "bottom": "999px"
        },
        src: imgSrc.value,
        ref_key: "upImg",
        ref: upImg,
        onLoad: imgLoad
      }, null, 40, _hoisted_7), [[_vShow, false]])]);
    };
  }

};